<template>
  <div class="website_container">
    <div class="website_content clearfix">
      <div class="website_content_left left">
        <div class="topicBox" v-on:mouseover="_stopScroll()" v-on:mouseout="_moveScroll()">
          <div class="caroufredsel_wrapper">
            <!--<ul class="clearfix" id="topicList">-->
            <transition-group tag="ul" class="clearfix" id="topicList" :name="animationName">
              <li
                class="img-list-li"
                v-for="(item,index) in imgList"
                v-show="index == imgIndex"
                :key="item.title"
              >
                <img :src="item.link" :alt="item.title" />
              </li>
            </transition-group>
            <!--</ul>-->
          </div>
          <div class="clearfix"></div>
          <a
            id="topic_prev"
            class="prev"
            href="javascript:void(0);"
            style="display: block;"
            @click="toggleImgIndex('prev')"
          ></a>
          <a
            id="topic_next"
            class="next"
            href="javascript:void(0);"
            style="display: block;"
            @click="toggleImgIndex('next')"
          ></a>
          <div id="topic_pager" class="topicPager" style="display: block;">
            <a
              v-bind:key="index"
              href="javascript:;"
              v-for="(item, index) in imgList"
              :class="{selected: index === imgIndex}"
              @click="toggleImgIndex(index)"
            >
              <span>{index + 1}</span>
            </a>
          </div>
        </div>
        <Carousel
          :animationName="animationName"
          title="猜你喜欢"
          :page="likeRadioPage"
          :musicList="likeRadioList"
          @togglePage="_togglePage(...arguments, 'like')"
          @showSign="$emit('toggle-show', true)"
          @play="gotoPlay"
        ></Carousel>
        <Carousel
          :animationName="animationName"
          title="热榜"
          :page="hotRadioPage"
          :musicList="hotRadioList"
          @togglePage="_togglePage(...arguments, 'hot')"
          @showSign="$emit('toggle-show', true)"
          @play="gotoPlay"
        ></Carousel>
        <div class="carousel" id="style">
          <div class="carouseTitle fontYaHei clearfix">
            <div class="left">
              风格
              <a
                href="javascript:;"
                data-type="0"
                class="more"
                @click="$emit('toggle-show', true)"
              >查看全部</a>
            </div>
            <div class="right">
              <ul class="style_list clearfix">
                <li
                  class="style_item left"
                  v-for="(item) in styleList"
                  :key="item"
                  @click="$emit('toggle-show', true)"
                >{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="website_content_right right">
        <a
          rel="nofollow"
          href="javascript:;"
          class="recommend_img"
          @mouseenter="showPlayBtn=true"
          @mouseleave="showPlayBtn=false"
          @click.stop="gotoPlay(recommend)"
        >
          <img :src="recommend.coverUrl" alt="今日推荐" style="width:250px;" />
          <span class="play_btn" v-if="showPlayBtn"></span>
        </a>
        <div class="recommend">今日推荐</div>
        <div class="riseList_container">
          <div class="riseList_header clearfix">
            <span class="left">飙升榜</span>
            <a href="javascript:;" class="right" @click="$emit('toggle-show', true)">查看全部</a>
          </div>
          <ul class="riseList_list">
            <li
              class="riseList_item clearfix"
              v-for="(item) in riseRadioList"
              :key="item.id"
              @click.stop="gotoPlay(item)"
            >
              <img :src="item.coverUrl" :alt="item.name" class="riseList_item_avatar left" />
              <div class="riseList_item_summary left">
                <p class="riseList_item_summary_title">{{ item.name }}</p>
                <p class="riseList_item_summary_author">{{ item.singer }}</p>
              </div>
              <span class="riseList_item_time right" v-if="item.duration">{{ item.duration }}</span>
              <span class="riseList_item_time right" v-else>- - : - -</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footer>
      <div class="footer_container clearfix fontYaHei">
        <div class="left">
          <div>
            <a
              target="_blank"
              :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + (config.policeLicense || '').match(/\d+/)[0]"
              v-if="config.policeLicense"
              style="display: inline-block; text-decoration: none; line-height: 20px;"
            >
              <img
                src=" data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAEUElEQVR4AY2UY2Bd6xJAd23bthXVthXrtae2bdu2bduNbeec2PZbN3NR68fnmTXcW+k7c9BPBwRUTvG9q7qzd5nNtS2LnaKdL08FdfVf6fwYlPayu8f1ZVePTxyVdtysNav09Vg7aQBnlo3g8ETjLHkj3XHQHwFJDS78bKcpOhW12WOuxdsp7Qgxr0fMrNb43Z/E1dNz0Cury6Mt+gCFfgmUcNLtF70arjWcXYsNSFraGNd8RXDRqYv3oCbYK3nJOtGHS3d3ITI5njtuiwM/BKYT0CTozsQMraqDMTVQkb29Oa51qsjAoXlVvPo2xrFiCV4VLwbPzZkyZy096vci4s2i0CiPHY2+A5Kyr8PerfNQlJVc2GZAvGlN8Q73NrVwr1oJp+JlxFOslLxEmTXh2ePl5MkznW3rF5DhtaL1V8BopxfVs5+PfLN723KUPAu5t7IrwX1q4qUUxL1WZTy61JYhewlb9njaLhAgSxcvgtj1z0mLq/MJ6HR93oy0s7qcObRWPOTuIX1SV2uJMlYGTXHd3xnN8+EEbu8rYUuBsHs9S4Ds27kGnPWJ8ru15hPQ5/H6gxEH2vPu+lKUwruYbmlJ5ttePBnUkPddauA+vjVe8/TwmaaNx+Y+EPw/Fo0zl2h492wDyTe7oX65/cQnoNfFaSF+6zqQYD2D6l0OiGWBEbG6C279mmLTuQ4eZu1w6dYQzQwtXMZ3pljBCVRqvYl4z/kE7tMl4LrK5xPQ+4pFiv1CPbjXn9nr9opl7iulyWleSrzj3Yj6uM3TFgNyxwulDIoykUnLt/P/dyNw2dCZ4CcTAz8B1fdW3vI/2Yts23G4PN2AUm07gxRdbpUsydvKRXnfqBy2uUN60bZLCybl1UIpvRjr+wvJcp5B8O2RRNut2/cJqLm36oPvru4EXxoLzirW7jgkXooXucOCISWHYF5zGMUVE7mTN2YvXg0+pmjumaC+PICojwvffgKGvV+S5XlcH49dI1Hv6UyizTTcXy5k7wJjpi7azN0zKuyujsDYbCFjhsxgzvzVxLy2JPxkZ3yO9EZ9czCxXiuiPwGzkmyNpC38zw7CbWcf3OY2Jv2tvngAnoMlT8Tf6CftAXHTZEWKKLISbqS1GZmxd7v8B/wEDf9gEh/6cjTOazrjvr0TcXbjiHxmSOit4YQ/MZAzCS6T8D/UC+/9A4iwnob69bToePW5Xt99enEBH7sH3VCFRb43JuKdBaEPxhL1cix/n1+ZE2dtIXCkePIW6zqTsLcqfC/oR/0QmByw+XFa8FzpK0m0DAFIfgRIxIMR4pmkhdDHRjKItptIkmY2SeG7r3wHlN9QpOeaPeqn+snhj4aSaDWG2OfDiLg1kOjcc/j1/uIxsR8NCX8xRPJGtP/KoNjw00t5vSLvT3+wnodml7deY2jyekWXo34XR7z3PjLcWX11hCbsnpHG74LR+9CnU59GOh3Y6nltTb9PoC/GX21leVIj+B9LAAAAAElFTkSuQmCC"
                style="float: left;"
              />
              <p
                style="float: left; line-height: 20px; margin: 0px 0px 0px 5px; color: rgb(147, 147, 147);"
              >{{config.policeLicense}}</p>
            </a>
          </div>
          <p v-if="config.icpLicense">
            <a target="_blank" href="https://beian.miit.gov.cn">{{config.icpLicense}}</a>
          </p>
          <p v-if="config.wangwenLicense">
            <a target="_blank" :href="config.wangwenLicenseUrl">{{config.wangwenLicense}}</a>
          </p>
          <p>{{config.companyFullName}}</p>
        </div>
        <div class="right">
          <a target="_blank" href="#/agreement">服务协议</a>
          <a target="_blank" href="#/privacy">隐私政策</a>
          <a target="_blank" href="#/copyright">版权投诉指引</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import config from "../../configCenter.json";
import Carousel from "@/components/carousel";
let banner1 = require("@/assets/banner1.jpg");
let banner2 = require("@/assets/banner2.jpg");
let banner3 = require("@/assets/banner3.jpg");
let banner4 = require("@/assets/banner4.png");

export default {
  data() {
    return {
      config,
      imgIndex: 0,
      imgList: [
        {
          title: "虽然看不见这个世界，但萧煌奇制造的阳光让我们无法自拔",
          link: banner1,
        },
        {
          title: "来自格陵兰的高冷情书，张洪量",
          link: banner2,
        },
        {
          title: "如果我们不曾相遇，五月天",
          link: banner3,
        },
        {
          title: "我好像在哪见过你，薛之谦",
          link: banner4,
        },
      ],
      styleList: ["摇滚", "民谣", "纯音乐", "电音", "翻唱", "流行"],
      animationName: "right",
      timeInterval: 3000,
      likeRadioPage: 0,
      likeRadioList: [],
      hotRadioPage: 0,
      hotRadioList: [],
      riseRadioList: [],
      recommend: [],
      durationArr: [233, 228, 239, 242, 221],
      showPlayBtn: false,
    };
  },
  created() {
    this._playScroll();
    this.$axios.post("/changsha/web/getMusicByType").then((res) => {
      if (res.status === 200 && res.data.rCode === 0) {
        let data = res.data.data.list;
        this.likeRadioList = this._formatList(data.like);
        this.hotRadioList = this._formatList(data.hot);
        this.riseRadioList = data.rise;
        this._getCurrentTime(this.riseRadioList);
        this.recommend = data.recommend[0];
      }
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  mounted() {
    document.title = config.companyFullName
  },
  components: {
    Carousel,
  },
  methods: {
    gotoPlay(music) {
      this.$router.push({
        path: "/play",
        query: { music },
      });
    },
    toggleImgIndex(index) {
      if (typeof index === "number") {
        if (this.imgIndex > index) {
          this.animationName = "left";
        } else {
          this.animationName = "right";
        }
        this.imgIndex = index;
      } else {
        if (index === "prev") {
          this.animationName = "left";
          this.imgIndex !== 0 ? --this.imgIndex : (this.imgIndex = 3);
        } else {
          this.animationName = "right";
          this.imgIndex !== 3 ? ++this.imgIndex : (this.imgIndex = 0);
        }
      }
    },
    _togglePage(page, str) {
      if (page === 0) {
        this.animationName = "left";
      } else {
        this.animationName = "right";
      }
      if (str === "like") {
        this.likeRadioPage = page;
      } else if (str === "hot") {
        this.hotRadioPage = page;
      }
    },
    _play() {
      this.animationName = "right";
      this.imgIndex++;
      if (this.imgIndex === this.imgList.length) {
        this.imgIndex = 0;
      }
    },
    // 开始滚动
    _playScroll() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
      this.timer = window.setInterval(this._play, this.timeInterval);
    },
    // 停止滚动 当鼠标移入
    _stopScroll() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // 开始继续滚动 当鼠标移出
    _moveScroll() {
      this._playScroll();
    },
    _getCurrentTime(list) {
      let i = list.length;
      while (i--) {
        let item = list[i];
        item.duration = this._formatTime(this.durationArr[i]);
      }
    },
    _formatList(list) {
      let rtn = [],
        arr = [];
      for (let i = 0; i < list.length; i++) {
        arr.push(list[i]);
        if ((i + 1) % 4 === 0) {
          rtn.push(arr);
          arr = [];
        }
      }
      return rtn;
    },
    _formatTime(ts) {
      let time = Math.floor(ts);
      let min = Math.floor(time / 60);
      let sec = Math.floor(time % 60);
      min = min < 10 ? `0${min}` : min;
      sec = sec < 10 ? `0${sec}` : sec;
      return `${min}:${sec}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "index";
</style>
